import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"min-width":_vm.width,"min-height":_vm.height,"max-height":_vm.height + 20,"max-width":_vm.width + 20,"color":_vm.color}},[_c(VCardText,{staticClass:"text-center"},[_c('span',{staticClass:"text",style:({ color: _vm.textColor(_vm.color) })},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.color)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }